import React, { useState, useRef } from "react";
import { Image, InputGroup, Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { DataType, stringToFunctionConverter } from "../../../utils";
import { AddToolTip, FormControlSearch } from "../../../components";
import { element } from "prop-types";

const FilterSourceForOutput = ({
  fields,
  setfields,
  filterObjectJson,
  fileName,
  filteredArray,
  fileFormatExtenstion,
  mapType,
}) => {
  const numberOfFields = fields.length;
  const [searchBar, showSearchBar] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const inputElem = useRef(null);
  const [showClear, setShowClear] = useState(false);

  const onClear = () => {
    inputElem.current.value = "";
    handleChange({
      target: {
        value: "",
      },
    });
    setShowClear(false);
  };
  const buttonClass =
    window.screen === "plan-group-home"
      ? "source-close-button-pg"
      : "source-close-button-wrapper";
  const iconClass =
    window.screen === "plan-group-home"
      ? "source-icon-size"
      : "source-close-button";
  const onMouseMove = () => {
    if (inputElem.current.value) {
      setShowClear(true);
    }
  };

  const onMouseOut = () => {
    setShowClear(false);
  };
  const handleChange = (e) => {
    //    e.preventDefault();
    setShowClear(true);
    // handleChange(e);
    setSearchTerm(e.target.value);
  };
  const closeButtonWrapperClass = showClear ? "active" : "";

  const CardComponent = ({
    element,
    index,
    isCollectionParent,
    parentIndex,
  }) => {
    return (
      <div>
        <Card
          style={{
            display: "flex",
            // border: "2px solid green",
            background: "#F7F7F7",
            width: "98%",
            height: "3.5rem",
            marginBottom: "0.5rem",
            borderRadius: "5px",
            justifyContent: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <input
              custom
              className="custom-control-label"
              type="checkbox"
              style={{
                display: "flex",
                alignSelf: "center",
                marginLeft: "0.50rem",
                width: "1rem",
              }}
              value=""
              onChange={() => {
                filteredArray = fields.filter((x) => x.selected == true)
                  ?.length;

                setfields(
                  fields.map((itm, idx) => {
                    if (idx === index && !isCollectionParent) {
                      return {
                        ...itm,
                        selected: !itm.selected,
                        SimOpt: "",
                        filterSelect: filteredArray == 0 ? true : false,
                      };
                    } else if (isCollectionParent && parentIndex === idx) {
                      return {
                        ...itm,
                        childObjectMaps: itm.childObjectMaps.map((val, key) => {
                          if (key === index)
                            return {
                              ...val,
                              selected: !val.selected,
                            };
                          return val;
                        }),
                      };
                    }
                    return itm;
                  })
                );
              }}
              checked={element.selected}
            />

            <div>
              <div style={{ display: "flex" }}>
                <div
                  className=" Flabel"
                  style={{
                    top: "15%",
                    paddingLeft: "1rem",
                    position: "absolute",
                    width: "220px",
                  }}
                >
                  <AddToolTip name={element.displayName} />
                </div>
                <div
                  className="Ftype"
                  style={{
                    position: "absolute",
                    top: "15%",
                    right: "0.25rem",
                    paddingRight: "0.25rem",
                  }}
                >
                  {DataType[element.dataType]}
                </div>
              </div>
              <div
                className="Ftype"
                style={{
                  width: "123px",
                  position: "absolute",
                  paddingLeft: "1rem",
                  bottom: "-10%",
                }}
              >
                <span className="fieldText">
                  <AddToolTip name={element.value || element.datum} />
                </span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  };

  return (
    <div className="FilterSourceContainer">
      <div className="FilterSourceSearchButtonContainer">
        <div className="FilterSourceTextContainer">
          <p className="FilterSourceText">Source</p>
        </div>
        {/* <div className="FiltersearchIconContainer">
          <Button
            variant="link"
            className="search-with-api-button"
            onClick={() => showSearchBar(!searchBar)}
          >
            <Image
              className="FiltersearchIcon"
              src="/assets/icons/svg/search.svg"
            />
          </Button>
        </div> */}
      </div>

      <div className="FileNameContainer">
        <div className="FilterFileNameText" id="MappingFileName">
          <AddToolTip
            name={`${
              mapType != 3 ? stringToFunctionConverter(fileName) : fileName
            }
          ${mapType != 3 ? fileFormatExtenstion : ""}`}
          />
        </div>
        <div className="FilterNumberOfFieldsText" id="NumberOfFields">
          {numberOfFields} Fields available in source file
        </div>
      </div>
      <div className="FilterSearchBarContainer mb-2">
        <Form>
          <InputGroup>
            {/* <div className="Filtermapper-source-search-text">
              <Form.Control
                ref={inputElem}
                // {...rest}
                size="sm"
                id="source-search-box"
                className="Filtersource-search-box"
                placeholder="Search source fields here"
                onChange={handleChange}
                // onKeyPress={onKeyPress}
                onFocus={onMouseOut}
                type="text"
              />
              <div
                className={`${buttonClass} ${closeButtonWrapperClass}`}
                onMouseMove={onMouseMove}
              >
                <button className={iconClass} type="button" onClick={onClear}>
                  <FontAwesomeIcon icon={faTimes} size={"sm" || "2x"} />
                </button>
              </div>
            </div> */}
            <FormControlSearch
              ref={inputElem}
              // {...rest}
              size="sm"
              id="source-search-box"
              className="Filtersource-search-box"
              placeholder="Search source fields here"
              onChange={handleChange}
              // onKeyPress={onKeyPress}
              onFocus={onMouseOut}
              type="text"
            />
          </InputGroup>
        </Form>
      </div>

      <div className="FilterCardRendering">
        <div>
          {fields &&
            fields.map((element, index) => {
              //element.childObjectMaps?.map((subHead, ind)=> ())

              const show_element = (item) => {
                if (searchTerm == "") {
                  return true;
                } else if (
                  item.propertyName
                    ? item.propertyName
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    : false
                ) {
                  return true;
                }
              };

              if (show_element(element)) {
                if (!element.isCollection) {
                  return <CardComponent element={element} index={index} />;
                }
                //  else {
                //   return element.childObjectMaps?.map(
                //     (collectionElement, ind) => (
                //       <CardComponent
                //         element={collectionElement}
                //         index={ind}
                //         parentIndex={index}
                //         isCollectionParent={true}
                //       />
                //     )
                //   );
                // }
              }
            })}
        </div>
      </div>
    </div>
  );
};

export default FilterSourceForOutput;
